
export default {
  welcome: 'خوش آمدید',
  language: 'زبان',
  loading: 'در حال بارگذاری...',
  sidebar: {
    navigation: 'منوی اصلی',
    collapse: 'جمع کردن منو',
    expand: 'باز کردن منو',
  },
  company: {
    name: CONFIG.COMPANY_NAME,
    app_title: CONFIG.APP_TITLE,
  },
  menu: {
    dashboard: 'داشبورد',
    product: ' محصولات',
    form: 'فرم',
    addProduct: 'افزودن محصول',
    organizations: 'سازمانها',
    transactions: 'تراکنش‌ها',
    transaction: 'تراکنش‌',
    ProductManage: 'مدیریت محصولات',
    campaign: 'کمپین',
    newBundle: 'ایجاد بسته جدید (باندل)',
    BoxManage: 'مدیریت بسته‌ها (باندل‌ها)',
    addCampaign: 'ایجاد کمپین',
    campaignManage: 'مدیریت کمپین‌ها',
    editCampaign: 'ویرایش کمپین‌',
    mission: 'ماموریت‌ها',
    misstionList: 'لیست ماموریت‌ها',
    missionManage: 'مدیریت ماموریت‌ها',
    scoreCampaign: 'کمپین امتیازی',
    codeBaseCampaign: 'کمپین کد محور',
    tieredPointsCampaign: 'کمپین امتیازات پلکانی',
    users: 'کاربران',
    financialReports: 'گزارشات مالی',
    financialTransactions: 'تراکنش‌های مالی',
    factors: 'فاکتورها',
    store: 'فروشگاه‌',
    listOfStoreProducts: 'لیست محصولات فروشگاه',
    createNewProduct: 'ایجاد محصول جدید',
    brands: 'برندها',
    categoryOfGoods: 'دسته‌های کالا',
    orders: 'سفارش‌ها',
    registeredOrders: 'سفارش‌های ثبت شده',
    abandonedShoppingCart: 'سبد خرید رها شده',
    paymentOfOrders: 'پرداخت‌های سفارش‌ها',
    discountCodes: 'کدهای تخفیف',
    insert_invoice: 'ایجاد فاکتور',
    notificationOfCampaigns: 'اطلاع‌رسانی کمپین‌ها',
    gifts: 'جوایز',
    uploadVoucher: 'آپلود وچر',
    addGiftProduct: 'ایجاد محصول جایزه',
    voucherStock: 'انبار وچرها',
    giftCategories: 'دسته بندی‌ها',
    giftProducts: 'اقلام جوایز',
    invoices: 'فاکتورهای ثبت شده',
    selledVouchers: 'جایزه‌های مصرفی',
    scoreRecords: 'امتیازهای کسب شده',
    reports: 'گزارشات',
    report: 'گزارش',
    grades: 'گروهبندی مشتریان',
    branches: 'شعبات',
    cities: 'شهرها',
    basicData: 'اطلاعات پایه',
    spins: 'نتایج گردونه',
    spinners: 'گردونه',
    spinnersList: 'لیست گردونه‌ها',
    spinnerItems: 'اجزای گردونه',
    addSpinner: 'ایجاد گردونه',
    SimCharge: 'شارژ',
    SimChargeReport: 'گزارش  شارژها',
    ScoreRatio: ' تبدیل سکه / ریال',
    voucherManagement:'مدیریت وچرها',
    uploadInvoice: 'آپلود فاکتور',
    // titles for routes outside the sidebar menu (route meta.title)
    notFound: 'صفحه پیدا نشد',
    editForm: 'ویرایش فرم',
    adminForm: 'فرم مدیریت',
    adminEditForm: 'ویرایش فرم مدیریت',
    ticketDetail: 'جزئیات تیکت',
    editInvoice: 'ویرایش فاکتور',
    editSurvey: 'ویرایش نظرسنجی',
    surveyAnalytics: 'تحلیل نظرسنجی',
    editProduct: 'ویرایش محصول',
    addSurvey: 'ایجاد نظرسنجی',
    medals: 'مدال‌ها',
    addGrade: 'ایجاد سطح',
    addMedal: 'ایجاد مدال',
    addContent: 'ایجاد بخش محتوا',
    addContactInfo: 'ایجاد اطلاعات تماس',
    addCategory: 'ایجاد دسته‌بندی',
    addBanner: 'ایجاد بنر صفحه اصلی',
    homeShortcuts: 'میانبرهای صفحه اصلی',
    editBanner: 'ویرایش بنر',
    editCategory: 'ویرایش دسته‌بندی',
    editGrade: 'ویرایش سطح',
    editMedal: 'ویرایش مدال',
    editContent: 'ویرایش بخش محتوا',
    editContactInfo: 'ویرایش اطلاعات تماس',
    addNotification: 'ارسال اعلان',
    addStore: 'افزودن فروشگاه',
    addGift: 'افزودن جایزه',
    voucherStorage: 'انبار وچرها',
    vouchersUsed: 'جایزه‌های مصرفی',
    invoiceReview: 'بررسی فاکتور',
    pageBuilder: 'صفحه‌ساز',
    ratioCoin: 'تبدیل نرخ امتیاز',
    docs: 'مستندات',
    generateVoucher: 'تولید وچر',
    importMobile: 'ورود شماره موبایل‌ها',
    codes: 'ورود کدها',
    userCredit: 'اعتبار کاربر',
    generatePasskeys: 'تولید پَس‌کی',
    addMission:'تعریف ماموریت',
    editMission:'ویرایش ماموریت'
  },
  datetime: {
    today: 'امروز {date} است',
    current: 'ساعت فعلی {time} است',
  },
  validation: {
    minDynamic: 'مقدار باید بزرگتر یا مساوی {min} باشد',
    maxDynamic: 'مقدار باید کوچکتر یا مساوی {max} باشد',
    rangeDynamic: 'مقدار باید بین {min} و {max} باشد',
    mobile: 'مقدار وارد شده اشتباه است',
    username: 'نام کاربری الزامی است',
    password: 'رمز عبور الزامی است',
    openError: ' خطا در ورود',
    passowrdError: 'نام کاربری یا رمز عبور اشتباه است',
    usernameMin: 'نام کاربری باید حداقل ۳ کاراکتر باشد',
    usernameMax: 'نام کاربری نمی‌تواند بیش از ۵۰ کاراکتر باشد',
    passwordMin: 'رمز عبور باید حداقل ۶ کاراکتر باشد',
    logoutSuccess: 'خروج موفق',
    logoutMessage: 'شما با موفقیت خارج شدید',
    passwordMax: 'رمز عبور نمی‌تواند بیش از ۲۰ کاراکتر باشد',
    changePassword: {
      placeholderCurrentPass: 'لطفا رمز عبور فعلی خود را وارد کنید',
      placeholderConfirmPass: 'لطفا رمز عبور جدید خود را وارد کنید',
      required: 'این فیلد الزامی است',
      requiredPass: 'رمز عبور الزامی است',
      minPass: 'رمز عبور باید حداقل ۸ کاراکتر باشد',
      capitalLetter: 'رمز عبور باید شامل حرف بزرگ باشد',
      smallLetter: 'رمز عبور باید شامل حرف کوچک باشد',
      number: 'رمز عبور باید شامل عدد باشد',
      specialChar: 'رمز عبور باید شامل کاراکتر خاص باشد',
      confirmed: 'رمز عبور و تکرار آن مطابقت ندارند',
    },
  },
  form: {
    search: 'جستجو',
    filter: 'فیلترها',
    fileUpload: 'آپلود فایل',
    save: 'ذخیره',
    isSaving: 'در حال ذخیره...',
  },
  table: {
    download: 'دانلود گزارش',
    file: 'دانلود فایل',
    empty:'داده ای یافت نشد',
    show:'نمایش',
    fromItem:'مورد از'
  },
  user: {
    login: 'ورود',
    logout: 'خروج',
    userSettings: 'تنظیمات کاربر',
    coinRani:'هر سکه رانی معادل',
    coinIrq:'هر سکه  معادل',
    rial:'ریال',
    yes: 'بله',
    no: 'خیر',
    confirm: 'ایا از خروج مطمئن هستین؟',
    logoutTitle: 'خروج از حساب کاربری',
    loginDesc: 'لطفا نام کاربری و رمز عبور خود را وارد کنید',
    username: 'نام کاربری',
    password: 'رمز عبور',
    currentPassword: 'رمز عبور فعلی',
    newPassword: 'رمز عبور جدید',
    confirmPassword: 'تایید رمز عبور جدید',
    confirmPassBtn: 'تایید',
    titleChangePass: 'تغییر رمز عبور',
    title2FA: 'ورود رمز دو مرحله‌ای',
    titleDisable2FA: 'غیرفعالسازی کد دو مرحله‌ای',
    btnConfirm2FA:'فعالسازی ورود دو مرحله‌ای',
    btnDisable2FA:'غیرفعالسازی کد دو مرحله‌ای',
    description2FA: 'بار کد زیر را در اپلیکیشن Google Authenticator اسکن کرده و کد تایید را وارد کنید. <br> دانلود از',
    descriptionDisable2FA: 'اپلیکیشن Google Authenticator را باز کنید و کد ۶ رقمی مربوط به حساب کاربری خود را وارد نمایید.',
    downloadFrom: 'دانلود از',
    googlePlay: 'Google play',
    appleStore: 'Apple store',
  },
  campaign: {
    EditCampaign: {
      modalConfirm: {
        title: 'تغییرات ذخیره نشده',
        description:
          'شما در حال ویرایش کمپین هستید و تغییرات ذخیره نشده‌اند. آیا مطمئن هستید که می‌خواهید بدون ذخیره خارج شوید؟',
        saveAndContinue: 'ادامه',
        leaveWithoutSave: 'خروج بدون ذخیره',
      },
    },
    createCampaign: {
      modalConfirm: {
        title: 'تغییرات ذخیره نشده',
        description:
          'شما در حال ایجاد کمپین هستید و تغییرات ذخیره نشده‌اند. آیا مطمئن هستید که می‌خواهید بدون ذخیره خارج شوید؟',
      },
    },
    campaignPage: {


      box1: {
        title: 'اطلاعات اولیه',
        name: 'عنوان کمپین',
        date: 'بازه کمپین',
        modelCampaign: 'نوع کمپین',
        calculation: 'محاسبه بر اساس',
        baseScore: 'امتیاز پایه (بابت هر سیکل خرید)',
        userLimit: 'محدودیت کاربران  ',
        unLimit:'(نامحدود)',
        toolTipBaseScore:'در این بخش، امتیاز پایه را مشخص می‌کنید.  این امتیاز زمانی به کاربر تعلق می‌گیرد که خرید محصول اصلی و محصولات مکمل (طبق شرایط تعریف‌شده) کامل انجام شود.',
        toolTipUserLimit:'در این بخش می‌توانید تعیین کنید هر کاربر حداکثر چند بار مجاز است امتیاز پایه این کمپین را دریافت کند.  * در صورتی که عدد (۰) را وارد کنید، دریافت امتیاز برای کاربران بدون محدودیت خواهد بود.'
      },



      box2: {
        addProduct:'افزودن محصولات',
        edit:'ویرایش',
        product:'محصول',
        vahed:'واحد',
        number:'تعداد',
        addCategory:'افزودن دسته بندی',
        category:'دسته بندی',
        totalInvoice:'جمع کل مبلغ فاکتور (ریال)',
        modelPackaging:'نوع بسته بندی',
        mablagh:'مبلغ (ریال)',
        minimumProduct:'حداقل محصول مکمل',
        minimumRow:'حداقل تعداد ردیفهایی که کاربر باید بخرد',
        modelProduct:'نوع محصول',
        minimunUse:'حداقل انجام موارد',
        toolTipModelProduct:'در این بخش، نوع هر محصول را مشخص می‌کنید:محصول اصلی: کاربر باید تعداد مشخصی از این محصول را بخرد تا امتیاز دریافت کند.محصول مکمل: محصول اختیاری است؛ معمولاً برای دریافت امتیاز، خرید همهٔ محصولات مکمل لازم نیست.*** برای تکمیل یک چرخه امتیازدهی، کاربر باید تمام شرط‌های تعریف‌شده را رعایت کند. این شرط‌ها ممکن است فقط شامل محصولات اصلی، فقط مکمل‌ها، یا ترکیبی از هر دو باشند — بسته به تنظیم شما.',
        toolTipMinimum:' این بخش تعیین می‌کند کاربر باید از چند محصول مکمل مختلف خرید کند تا امتیاز بگیرد.برای مثال، اگر ۱۰ محصول مکمل تعریف شده باشد و شما مقدار **حداقل محصول مکمل را روی ۴ تنظیم کنید، کاربر باید از بین این ۱۰ محصول، حداقل ۴ نوع مختلف را خریداری کند تا امتیاز دریافت کند.'
      },

      box3: {
        title:'پلکان امتیاز',
        addStairs:'افزودن پله امتیاز',
        edit:'ویرایش',
        cycleNum:'تعداد چرخه',
        ExtrScore:'امتیاز اضافه',
        toolTipStairs:'در این بخش می‌توانید پلکان امتیاز را تعریف کنید.*** پلکان امتیاز مشخص می‌کند کاربر پس از تکمیل چند چرخه خرید، چه میزان امتیاز اضافه دریافت می‌کند.مثال:اگر در تنظیمات تعریف شود:چرخه ۱۰ = ۵۰۰ امتیاز کاربر پس از تکمیل ۱۰ چرخه، علاوه بر امتیازهای پایه، ۵۰۰ امتیاز اضافه دریافت خواهد کرد.',
        toolTipCycle:'تعداد چرخه، تعداد دفعاتی است که کاربر باید شرایط خرید را کامل انجام دهد تا واجد دریافت امتیاز اضافه شود.مثال: اگر تعداد چرخه روی ۱۰ تنظیم شود، کاربر باید ۱۰ بار خرید کامل (محصول اصلی و مکمل) انجام دهد.',
        toolTipExtraScore:'امتیاز اضافه، پاداشی است که پس از رسیدن کاربر به تعداد مشخصی از چرخه‌های کامل، علاوه بر امتیازهای پایه به او تعلق می‌گیرد.مثال: مثلاً اگر امتیاز اضافه برای چرخه ۱۰ برابر با ۵۰۰ باشد، کاربر پس از تکمیل ۱۰ چرخه، ۵۰۰ امتیاز اضافه دریافت می‌کند.'
      },

      box4:{
        title:'ویژگی‌ها',
        city:'شهر/نماینده',
        userClass:'کلاس مشتری',
        storeModel:'نوع فروشگاه',
        toolTipCity:'از این بخش می‌توانید مشخص کنید که کمپین در کدام شهرها فعال باشد"',
        toolTipUserClass:'از این بخش می‌توانید تعیین کنید کمپین برای کدام دسته یا کلاس از کاربران فعال باشد.',
        toolTipStoreModel:'از این بخش می‌توانید تعیین کنید کمپین برای چه نوع فروشگاه‌هایی فعال باشد.',
      },

      box5: {
        title:'اطلاعات تکمیلی',
        selectFile:'انتخاب فایل',
        showCampaign:'نمایش کمپین',
        shortDesc:'توضیحات کوتاه',
        fullDesc:'توضیحات کامل',
      }
    }
  },

  dashboard: {
    summary: {
      title: 'خلاصه',
      totalCampaigns: 'تعداد کمپین‌ها',
      totalUsers: 'تعداد کاربران',
      totalPointsEarned: 'مجموع امتیازات کسب شده',
      totalPointsSpent: 'مجموع امتیازات مصرف شده',
      totalTransactions: '',
      totalPointsRedeemed: '',
      installmentsDue: '',
      voucherPurchases: ''

    },
    summaryReport: {
      title: 'خلاصه گزارشات',
      topSalesCampaigns: 'کمپین‌های پر فروش',
      topCities: 'برترین شهرها',
      topUsers: 'برترین کاربران',
    },
  },
  fileManager: {
    modalDetails: {
      title: 'جزئیات فایل',
      notSelected: 'هیچ فایلی انتخاب نشده است',
      name: 'نام فایل',
      createUpload: 'تاریخ بارگذاری',
      created: 'تاریخ ایجاد',
      size: 'حجم فایل',
      download: 'دانلود',
      moveTo: 'انتقال به پوشه',
      delete: 'حذف فایل',
    },

    mainFileManager: {
      title: 'مدیریت فایل‌ها',
      folders: 'پوشه‌ها',
      files: 'فایل ها',
      emptyFile: 'فایل خالی است',
      descEmptyFile: 'هنوز فایل یا پوشه ای در این محل وجود ندارد',
    },

    cardFileManager: {
      edit: 'ویرایش',
      delete: 'حذف',
      move: 'انتقال',
    },

    headerFileManager: {
      newFile: 'فایل جدید',
      newFolder: 'پوشه جدید',
      searchFile: 'جستجو',
      fileManager: 'مدیریت فایل‌ها',
      uploadDetail: {
        descUploadFile: 'برای بارگذاری فایل خود را اینجا بکشید و رها کنید',
        or: 'یا',
        select: 'انتخاب کنید',
        maxSize: 'حداکثر اندازه فایل اپلود',
        format: 'فرمت مجاز',
        mb: 'مگابایت',
      },
    },

    footerFileManager: {
      confirm: 'تایید',
      moveTo: 'انتقال به',
      cancelMove: 'لغو انتقال',
    },

    modalCreateFolder: {
      createFolder: 'ایجاد پوشه جدید',
      name: 'نام پوشه',
      nameFile: 'نام فایل',
      confirm: 'تایید',
      cancel: 'انصراف',
    },

    modalEdit: {
      titleFolder: 'تغییر نام پوشه',
      titleFile: 'تغییر نام فایل',
      confirm: 'تایید',
      cancel: 'انصراف',
      message: 'با این نام از قبل وجود دارد',
      folder: 'پوشه',
      file: 'فایل',
    },

    modalDelete: {
      title1: 'ایا از حذف ایتم',
      title2: 'اطمینان دارید؟',
      yesDelete: 'بله حذف شود',
      noDelete: 'خیر منصرف شدم',
    },
  },
  RatioCoins: {
    title: 'تبدیل نرخ امتیاز',
    coin: 'هر تعداد سکه رانی برابر است با (ریال):',
    submit: 'ثبت نرخ تبدیل',
    modal: {
      title: '  آیا از اعمال این تغییر اطمینان دارید؟',
      desc1:
        ' با تغییر نرخ تبدیل امتیاز، ارزش تمام امتیازهای کاربران به‌روزرسانی می‌شود. این تغییر بر محاسبات اعتبار کاربران در باشگاه مشتریان تأثیر می‌گذارد.',
      desc2: '    لطفاً قبل از تأیید، از صحت اطلاعات واردشده مطمئن شوید.',
      cancel: '    لغو/بازگشت',
      yes: '  تأیید و اعمال تغییرات',
    },
    what: 'در این جدول می‌توانید مشخص کنید هر چند سکه رانی معادل چه مقدار اعتبار ریالی باشد.',
    toolTip: {
      success: {
        header: 'موفق',
        body: 'تبدیل نرخ امتیاز با موفقیت انجام شد'
      },
      error: {
        header: 'خطا',
        body: 'تبدیل نرخ امتیاز با موفقیت انجام نشد'
      }
    }
  },


}
